import type { SavedOnlineRating } from '../domain/online-rating';
import { tf } from '../i18n';
import { RatingStars } from './RatingStars';

/**
 * A "Note en ligne" (owner requests, 2026-10-03): only the rating, on the app's 5-point scale,
 * marked as found online by a globe and a blue tint rather than words. Its accessible name says
 * "Note en ligne : 4.5/5".
 */
export function OnlineRatingValue({
  saved,
  compact = false,
}: {
  saved: SavedOnlineRating;
  /** The globe and the number only, for the compact wine card (owner, 2026-10-13). */
  compact?: boolean;
}) {
  const rating = String(saved.rating);
  return (
    <span
      className="online-score"
      role="img"
      aria-label={tf('rating.onlineA11y', { rating })}
      title={tf('rating.onlineA11y', { rating })}
    >
      <svg
        className="online-score__globe"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3 12h18M12 3c2.5 2.7 3.5 5.7 3.5 9s-1 6.3-3.5 9c-2.5-2.7-3.5-5.7-3.5-9s1-6.3 3.5-9z" />
      </svg>
      {compact ? (
        rating
      ) : (
        <>
          <RatingStars rating={saved.rating} />
          {tf('rating.outOfFive', { rating })}
        </>
      )}
    </span>
  );
}
